export default "__VITE_ASSET__CRgM3NRM__"